import React  from 'react';
//前言

const Enclosure41 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
            <h3 style={{textAlign:'center'}}>第一部分   总则</h3>
            <p>第一条 为了更好地贯彻安全生产方针、政策、法规，落实安全生产的各项规章制度，促进企业安全发展，结合公司实际，特制定本规则。</p>
            <p>第二条 公司建立安全问责制度、安全奖管理办法、人身伤亡事故处理办法、道路交通事故处理办法、设备事故处理办法、消防事故处理办法、生产事故处理办法、治安事件处理办法、违章违制处理办法等制度，促进公司安全生产岗位责任制的全面落实。</p>
            <p>第三条 本规则是公司安全生产事故（事件）处理工作的纲领性文件。 公司合同制职工均按照本规则执行，其他在公司区域作业的人员，按照有关协议及相关规定执行。</p>
            <p>本规则所述事故（事件），包括公司的各类事故、事件及违章违制现象。</p>
            <p>第四条 安全生产事故（事件）的事后处理工作，坚持<strong>“谁主管谁负责、谁在岗谁负责、谁出问题谁负责”</strong>的原则。</p>
            <p>各事业部负责所辖区域安全生产事故（事件）的日常管理工作。 </p>
            <br/>
            <h3 style={{textAlign:'center'}}>第二部分 安全生产事故等级分类 </h3>
            <p>第五条 安全生产事故是指职业活动或有关活动过程中发生的意外、突发性事件的总称，通常会使正常活动中断、造成人员伤亡或财产损失。 </p>
            <p>１、按伤害程度分:职工伤亡事故按伤害程度分为轻伤事故、重伤事故、死亡事故、重大死亡事故、特大死亡事故。</p>
            <p>2、按经济损失程度分:根据事故造成的经济损失程度，事故通常分为一般损失事故、较大损失事故、重大损失事故、特大损失事故。</p>
            <p>第六条 公司根据事故伤害程度、经济损失程度，将各类事故分为四个等级，即：Ⅰ级（轻微事故）、Ⅱ级（一般事故）、Ⅲ级（重大事故）、Ⅳ级（重特大事故）。 </p>
            <p>Ⅰ级事故，如：轻微交通事故、出现火警； </p>
            <p>Ⅱ级事故，如：轻微人身伤害事故、一般交通事故、一般火灾、一般设备事故；</p>
            <p>Ⅲ级事故，如：轻伤事故、重大交通事故、重大火灾、重大设备事故； </p>
            <p>Ⅳ级事故，如：重伤及工亡事故、特大交通事故、特大火灾事故、特大设备事故。 </p>
            <p>第七条 安全生产事故等级应由事故调查组分析确定。 </p>
            <br/>
            <h3 style={{textAlign:'center'}}>第三部分 安全生产事故责任分类</h3>
            <p>第八条 安全生产事故根据性质分为责任事故、非责任事故或破坏事故。 责任事故和破坏事故应进行处罚。 非责任事故可不进行处罚。 </p>
            <p>第九条 为准确地对不同事故责任人进行处罚，应根据事故调查组所确认的事实，分清事故责任：</p>
            <p> 1、直接责任者，指其行为与事故的发生有直接关系的人员。</p>
            <p> 2、主要责任者，指对事故的发生起主要作用的人员。 </p>
            <p> 3、领导责任者，指对事故的发生负有领导责任的人员。 </p>
            <p>第十条 安全生产事故责任的认定应由事故调查组确定。</p>
            <br/>
            <h3 style={{textAlign:'center'}}>第四部分 违章违制等级分类 </h3>
            <p>第十一条 公司将各类违章分为四个等级，即：Ⅰ级（行为疏忽）、Ⅱ级（一般违章）、Ⅲ级（严重违章）、Ⅳ级（重大违章）。 </p>
            <p>第十二条 违章行为等级的评价，由各专业检查组或主管部门组织三名以上（含）专业人员进行会商确定，公司安全部门具有最终裁决权。</p>
            <br/>
            <h3 style={{textAlign:'center'}}>第五部分 安全生产事故（事件）的报告、调查处理</h3>
            <p>第十三条 公司安全生产事故管理部门为相关事故报告的主管部门，负责事故（事件）的接案、上报和事故（事件）调查处理的组织工作。 </p>
            <p>第十四条 公司安全生产事故（事件）主管部门负责完善事故（事件）报告的实施办法。</p>
            <p>第十五条 安全生产事故（事件）发生后，公司安全生产事故主管部门应及时组织事故（事件）调查组，开展事故（事件）调查、分析工作，确定事故（事件）性质，划分事故（事件）责任。上级主管部门组织调查组的，公司安全生产事故（事件）主管部门应积极配合其工作。</p>
            <p>第十六条 公司安全生产事故主管部门应建立和相关单位关于事故调查处理的协调机制，完善沟通渠道和信息公开办法。 </p>
            <br/>
            <h3 style={{textAlign:'center'}}>第六部分 惩罚 </h3>
            <p>第十七条 安全生产事故（事件）发生后，对相关部门领导和责任者的惩罚工作，必须结合事故（事件）的类型、等级和责任大小有针对性的进行。</p>
            <p>第十八条 惩罚类型</p>
            <p> 1、根据情节的轻重程度，及时采取批评教育、书面检查、通报全厂、待岗学习、经济处罚、行政处罚等办法予以处罚。除对直接责任者进行处罚外，同时追究部门各级领导及与此事件相关的所有人员的责任。</p>
            <p> 2、经济处罚根据危害程度和损失情况、责任大小，可处以罚款、赔偿损失、降低工资、扣除奖金、没收押金等。 </p>
            <p> 3、行政处罚根据危害程度和损失情况、责任大小可处以警告、诫勉谈话、记过、降职、降级、留厂查看、开除等。 </p>
            <p> 4、性质特别严重、情节恶劣，触犯刑律者，追究法律责任</p>
            <p><strong>第十九条 各类事故（事件）的惩罚标准：根据公司董事会决定，在公司安全生产过程中发生的责任性事故（事件）对公司造成的财产损失，各责任者需承担损失，承担比例为：事故（事件）直接责任者承担40%，直接责任者的部门第一责权人承担30%，公司承担30%。</strong></p>
            <p>第二十条 惩罚程序</p>
            <p> 1、经济处罚由相关主管部门提出处理意见，报分管副总经理批准后执行。 </p>
            <p> 2、行政处罚由相关主管部门提出处理意见，按公司有关规定参照任命程序，报有关领导批准后执行。</p>
            <br/>
            <h3 style={{textAlign:'center'}}>第七部分 奖励 </h3>
            <p>第二十一条 奖励类型</p>
            <p>奖励实行精神奖励和物质奖励相结合的原则。物质奖励可发给一次性奖金、奖品或晋级，精神奖励包括记功、授予荣誉称号等。 </p>
            <p>第二十二条 公司设立“安全奖”，制定奖罚措施，对安全工作做得好的部门进行奖励，具体办法另行制定。</p>
            <p>第二十三条 具有以下情况的，公司可予以奖励</p>
            <p> 1、在安全技术、工业卫生方面积极采取先进技术，提出重要建议被采用有明显的效果者，有发明创造或科研成果，成绩显著的。</p>
            <p> 2、认真贯彻公司的安全生产方针、规章、制度，在预防事故、安全生产过程中作出显著成绩的。 </p>
            <p> 3、制止违章指挥、制止违章作业避免事故发生者</p>
            <p>第二十四条 本规则自公布之日起执行。</p>
            <br/><br/>
        </div>
    </div>


export default Enclosure41;